import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CategoryEntity } from './category.entity';
import { PriceContractEntity } from './price-contract.entity';

@Index('fk_category__id', ['fkCategoryId'], {})
@Index('fk_price_contract__id', ['fkPriceContractId'], {})
@Index(
	'price_contract_category_item_constraint',
	['fkPriceContractId', 'fkCategoryId', 'startDate', 'endDate'],
	{},
)
@Entity('price_contract_category_item')
export class PriceContractCategoryItemEntity extends BaseEntity {
	@Column('int', { name: 'fk_price_contract__id', unsigned: true })
	public fkPriceContractId!: number;

	@Column('int', { name: 'fk_category__id', unsigned: true })
	public fkCategoryId!: number;

	@Column('date', { name: 'startDate', nullable: true })
	public startDate!: string | null;

	@Column('date', { name: 'endDate', nullable: true })
	public endDate!: string | null;

	// Price config. A row participates in PRICE matching only when priceValue is
	// non-null; a cost-only row leaves these null (hence priceType is nullable).
	@Column('varchar', { name: 'priceType', nullable: true, length: 32 })
	public priceType!: string | null;

	@Column('varchar', { name: 'priceSource', nullable: true, length: 255 })
	public priceSource!: string | null;

	@Column('decimal', {
		name: 'priceValue',
		nullable: true,
		precision: 15,
		scale: 6,
	})
	public priceValue!: string | null;

	// Cost config. A row participates in COST matching as a single unit when
	// either acquisitionCostValue or sellCostValue is non-null. The winning cost
	// row supplies both values; a null value means "inherit the item's cost".
	@Column('varchar', {
		name: 'acquisitionCostType',
		nullable: true,
		length: 32,
	})
	public acquisitionCostType!: string | null;

	@Column('varchar', {
		name: 'acquisitionCostSource',
		nullable: true,
		length: 255,
	})
	public acquisitionCostSource!: string | null;

	@Column('decimal', {
		name: 'acquisitionCostValue',
		nullable: true,
		precision: 15,
		scale: 6,
	})
	public acquisitionCostValue!: string | null;

	@Column('varchar', { name: 'sellCostType', nullable: true, length: 32 })
	public sellCostType!: string | null;

	@Column('varchar', { name: 'sellCostSource', nullable: true, length: 255 })
	public sellCostSource!: string | null;

	@Column('decimal', {
		name: 'sellCostValue',
		nullable: true,
		precision: 15,
		scale: 6,
	})
	public sellCostValue!: string | null;

	@Column('int', { name: 'priority', unsigned: true, default: () => "'0'" })
	public priority!: number;

	@ManyToOne(
		() => CategoryEntity,
		(category) => category.priceContractCategoryItems,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_category__id', referencedColumnName: 'id' }])
	public category!: CategoryEntity;

	@ManyToOne(
		() => PriceContractEntity,
		(priceContract) => priceContract.priceContractCategoryItems,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_price_contract__id', referencedColumnName: 'id' }])
	public priceContract!: PriceContractEntity;
}
